export const WHATSAPP = {
  PHONE_NUMBER: '17026024236',
  DEFAULT_MESSAGE:
    "Hi Iris, I'm ready to transform my career. How can you help me?",
  BASE_URL: 'http://wa.me'
} as const

export const getWhatsAppUrl = (
  phoneNumber: string = WHATSAPP.PHONE_NUMBER,
  message: string = WHATSAPP.DEFAULT_MESSAGE
) => {
  const encodedMessage = encodeURIComponent(message)
  return `${WHATSAPP.BASE_URL}/${phoneNumber}?text=${encodedMessage}`
}
